import { FieldMeta } from '@/modules/dynamic-form/models/FieldMeta.model';
import { FieldSchema } from '@/modules/dynamic-form/models/FieldSchema.model';
import { COUNTRIES_ISO_3166_1 } from '@/modules/entity-management/constants/countryCodes';

import { toFieldPath } from '../../to-field-path/toFieldPath';

const defaultValue = {
    country: undefined,
    street: undefined,
    aptSuiteOrUnit: undefined,
    city: undefined,
    state: undefined,
    zipCode: undefined,
};

export function createAddressFieldMeta(schema: FieldSchema): FieldMeta {
    const properties: Record<string, FieldMeta> = {
        country: {
            path: toFieldPath('country'),
            label: 'Country',
            type: {
                $type: 'Enum',
                values: COUNTRIES_ISO_3166_1.map(
                    (x) => ({ value: x.code, label: x.label || x.name }),
                ),
            },
            required: true,
            defaultValue: undefined,
        },
        street: {
            path: toFieldPath('street'),
            type: { $type: 'String' },
            label: 'Street Address',
            required: true,
            defaultValue: undefined,
        },
        aptSuiteOrUnit: {
            path: toFieldPath('aptSuiteOrUnit'),
            type: { $type: 'String' },
            label: 'Apt, Suite or Unit',
            defaultValue: undefined,
        },
        city: {
            path: toFieldPath('city'),
            type: { $type: 'String' },
            label: 'City',
            required: true,
            defaultValue: undefined,
        },
        state: {
            path: toFieldPath('state'),
            type: { $type: 'String' },
            label: 'State',
            required: true,
            defaultValue: undefined,
        },
        zipCode: {
            path: toFieldPath('zipCode'),
            type: { $type: 'String' },
            label: 'Zip',
            required: true,
            defaultValue: undefined,
        },
    };
    return { ...schema, properties, defaultValue };
}
